import React, { useEffect, useState } from 'react';
import StockMetricTable from './StockMetricTable';
import './SignalComponent.css';

const SignalComponent = () => {

  const[data, setData] = useState([]);

  useEffect(() => {
    const fetchStockSignals = async () => {
        try {
            console.log("fetching stock signals data");
            const url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_STOCK_SERVICE_DEV : "";
            const response = await fetch(url + '/stocksignals');
            console.log("response:", response);
            const result = await response.json();
            console.log("result:", result);
            setData(result);

        } catch (error) {
            console.error("Error fetch stock metrics. ", error);
        }
    };

    fetchStockSignals();
  }, []);

  const columns = [
    {
      Header: 'ticker',
      accessor: 'ticker', // accessor is the "key" in the data
    },
    {
      Header: 'Index',
      accessor: 'indexName',
    },
    {
      Header: 'Sector',
      accessor: 'sector',
    },
    {
    Header: 'Industry',
    accessor: 'industry',
    },
    {
      Header: 'Update Date',
      accessor: 'updateDate',
    },
    {
      Header: 'Signal Type',
      accessor: 'signalType',
    },
    {
      Header: 'Score',
      accessor: 'score',
    }
    ];
    return (
        <React.Fragment>
            <div>
                <h1>Stock Signal Table</h1>
                <StockMetricTable columns={columns} data={data}></StockMetricTable>
            </div>
        </React.Fragment>
    );
};

export default SignalComponent;
